import React from 'react';
import { GradientText } from '../../flayr-components/GradientText/GradientText';

interface ILogoProps {
  className?: string;
  size?: string;
  bg?: string;
  mini?: boolean;
}

const Logo: React.FC<React.PropsWithChildren<ILogoProps>> = ({
  className = '',
  size = 'text-3xl',
  bg = 'bg-primary-to-r',
  mini,
}) => {
  return (
    <div className={`${size} ${className}`}>
      {!mini && <GradientText text="Flayr" gradientClassName={bg} />}
      {
        mini && <>F</>

        //   <svg
        //     xmlns="http://www.w3.org/2000/svg"
        //     width="1em"
        //     height="1em"
        //     version="1.1"
        //     viewBox="0 0 400 400"
        //   >
        //     <g fillRule="evenodd" stroke="none">
        //       <path
        //         fill="#5b14ec"
        //         d="M129 55.065c-7.801.979-15.155 7.618-17.219 15.544-.882 3.386-.876 277.818.006 281.204 5.228 20.073 34.083 21.167 41.846 1.587l.951-2.4.208-60.6.208-60.6 7.8-.247c4.29-.136 29.04-.283 55-.328 25.96-.045 48.55-.233 50.2-.419 20.869-2.342 25.454-29.752 6.4-38.266-3.892-1.739-3.729-1.734-62.4-1.839-30.91-.056-56.425-.247-56.7-.425-.395-.255-.5-9.913-.5-46.076s.105-45.821.5-46.076c.275-.178 30.83-.426 67.9-.55 73.182-.246 67.925-.082 72.148-2.244 1.291-.66 4.858-3.464 5.763-4.528 9.993-11.754 5.637-27.658-9.111-33.269-1.309-.498-159.151-.951-163-.468"
        //       />
        //       <path
        //         fill="#fa05fb"
        //         d="M289.6 54.8l-1 .32 1.04.04c4.599.176 11.834 5.334 14.488 10.329 3.992 7.513 2.839 16.425-3.017 23.313-2.653 3.121-8.424 6.294-11.711 6.44l-1.2.053 1.2.305c2.888.735 12.449.225 16.2-.863 4.298-1.247 10.321-5.916 12.049-9.34.332-.658.799-1.557 1.038-1.997 5.2-9.571-1.026-23.79-12.087-27.603-3.061-1.056-14.688-1.737-17-.997M154.984 96.5c-.104.275-.144 21.02-.087 46.1l.103 45.6h13.6l.102-46.1.101-46.1h-6.814c-5.083 0-6.862.127-7.005.5M270.2 189.186c.44.197 1.117.37 1.504.386 2.059.082 7.341 3.312 9.785 5.982 9.56 10.448 3.912 29.661-9.589 32.62-.605.133-1.1.446-1.1.696 0 .768 12.536.108 15.303-.805 19.17-6.324 18.669-33.835-.703-38.586-2.069-.508-16.293-.782-15.2-.293M154.991 230.1c-.101.275-.233 27.59-.294 60.7l-.112 60.2-.952 2.4c-2.245 5.659-9.549 13-12.934 13-.33 0-.323.136.027.486.797.797 10.625.657 12.958-.186 7.557-2.728 12.986-8.705 14.557-16.028.427-1.989.534-14.069.545-61.772l.014-59.3h-6.813c-5.085 0-6.859.127-6.996.5"
        //       />
        //       <path
        //         fill="#05fbfb"
        //         d="M114.8 55.065c-7.638 1.188-14.613 7.463-16.824 15.135-1 3.472-.852 279.538.152 282.669 3.186 9.939 12.401 15.6 23.674 14.544 3.702-.347 3.701-.404-.051-2.615-5.145-3.033-8.517-7.427-9.964-12.985-.882-3.386-.888-277.818-.006-281.204 1.069-4.104 5.301-10.295 8.282-12.114 2.664-1.626 4.372-2.495 4.903-2.495.299 0 1.058-.269 1.688-.598 1.118-.583-8.514-.857-11.854-.337"
        //       />
        //     </g>
        //   </svg>
        // )
      }
    </div>
  );
};
export default Logo;
